import { render, staticRenderFns } from "./upData.vue?vue&type=template&id=f973a412&slot-scope=scope&"
import script from "./upData.vue?vue&type=script&lang=js&"
export * from "./upData.vue?vue&type=script&lang=js&"
import style0 from "./upData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports